import { serverBus } from '@/main'
import SessionManager from '@/Manager/Session.manager'
import ChannelNotification from '@/Manager/Notification/Channel.manager'
import Global from '@/scripts/Global'
import ChannelApi from '@/scripts/api/channel.api'
import { CPUtils } from '@/scripts/Utils';
import VueSignals from '@/scripts/VueSignals';

export default {
    name: 'InviteUser',
    data (){
        return {
          activeChannelDoc: SessionManager.getActiveChannel(),          
          showModal: false,
          mainSpinner: false,
          organisationUsers: SessionManager.getUsers(),
          userSuggestion: [],
          noSuggestion: 'Start typing a user name to get suggestions.',
          inviteeIds: [],
          response: null,
          deleteEntery: false,
          overlayType : Global.getGlobalSessionValue(VueSignals.OVERLAY_TYPE),
          userIsAdmin: false,
          addInviteUserForm: false,      
          inviteSearch: '',    
          invitationInputCounter:0,
          inputFields:[],
          noChoosenUser: false,
          subfolder: false,
        }
      },
    mounted(){      
      this.subfolder = this.$parent.data.subfolder      
      serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (ch_id) => {
        this.activeChannelDoc = SessionManager.getActiveChannel()
      })      

      if(document.querySelector('.active-input') != null){
        document.querySelector('.active-input').focus()        
      }      

      let arrInvitedUserIds = []
      let channelUserIds = SessionManager.getActiveChannel().user_ids
      let invitations = SessionManager.getActiveChannel().invitations
      let arr = []
      this.activeChannelDoc = SessionManager.getActiveChannel()        
      this.userIsAdmin = SessionManager.getActiveChannel().admin
      Global.globalValue(VueSignals.USER_CHANNEL_RIGHTS, this.userIsAdmin)

      /*Filter the suggestion from invitation users*/
      if(typeof invitations != 'invitations'){
        for(let currInvitation in invitations){
          if(typeof invitations[currInvitation].user_cp_id != 'undefined' &&
          invitations[currInvitation].user_cp_id != ''){
            arrInvitedUserIds.push(invitations[currInvitation].user_cp_id)
          }
        }
      }      

      for(let i=0; i< this.organisationUsers.length;i++){
        if(typeof channelUserIds != 'undefined' && !channelUserIds.includes(this.organisationUsers[i].user_id)){
          arr.push(this.organisationUsers[i]) 
        }
      }
    

      let finalArr = []
      arr.forEach(currUser=> {
        if(!arrInvitedUserIds.includes(currUser.user_id)){
          finalArr.push(currUser)
        }
      })
      this.organisationUsers = finalArr  
      /*Filter the suggestion from the current channel users*/
     
     

      serverBus.$on(VueSignals.OVERLAY_TYPE, (overlayType) => {
        this.overlayType = overlayType;
      })


    },
    created() {
     serverBus.$on(VueSignals.SHOW_MODAL, (modalStatus) => {
      this.showModal = modalStatus;
     })
           
    },
  methods: {
    addInput(){            
      this.invitationInputCounter++
      while(this.inputFields.includes(this.invitationInputCounter)){
        this.invitationInputCounter++
      }
      this.inputFields.push(this.invitationInputCounter)      
           
    },
    getUserDetails(user_id){           
      return SessionManager.getUser(user_id);
    },     
    suggest(id){
       this.userSuggestion = []
       this.noSuggestion = ''
       this.inviteSearch = document.getElementById(id)
       let search_pattern = this.inviteSearch.value.toLowerCase()
       this.organisationUsers.forEach(currUser => {
         if(currUser.username.toLowerCase().indexOf(search_pattern) != -1){
           if(!this.userSuggestion.some(filterUser=> {
             return filterUser.username.toLowerCase() == currUser.username.toLowerCase()
           }))
           this.userSuggestion.push(currUser)
         }
         else if(currUser.email.toLowerCase().indexOf(search_pattern) != -1){
           if(!this.userSuggestion.some(filterUser=> {
               return filterUser.email.toLowerCase() == currUser.email.toLowerCase()
             })){
             this.userSuggestion.push(currUser)
           }
         }         
       })

       if(search_pattern.length > 0 && this.userSuggestion == 0){
          this.noSuggestion = "No one found matching \"" + search_pattern+ " \""
       }
       if(search_pattern === ''){
         this.noSuggestion = 'Start typing a user name to get suggestions.'
         this.userSuggestion = []
       }
     },
     addInviteUser(user_id){
      if(!this.inviteeIds.includes(user_id) && user_id.length > 0){
          this.inviteeIds.push(user_id)
      }
      this.userSuggestion = []
     },        
     inviteUsers(){
      /**
       * get the inputs
       */
       for(let i=0;i <= this.invitationInputCounter;i++){
          let input = document.getElementById('invitation_input_'+i)
          if(input != null && input.value.length > 0){
              if(typeof input.dataset.id != 'undefined' && !this.inviteeIds.includes(input.dataset.id)){
                this.inviteeIds.push(input.dataset.id)
            }else {
              if(CPUtils.hasEmail(input.value)){
                  this.inviteeIds.push(input.value)  
              }else {
                break
              }          
            }
          }
       }

       if(this.userSuggestion.length  == 1){
         let CPUser = SessionManager.getUser(document.querySelector(".suggestion > li").id)
         if(typeof CPUser != 'undefined' && CPUser != null){
          this.inviteeIds.splice(this.inviteeIds.indexOf(CPUser.email), 1)          
          if(CPUser.user_id){
            this.inviteeIds.push(CPUser.user_id)
          }          
         }        
       }




       let data_invitees = {         
         "channel_id": this.activeChannelDoc.channel_id,
         "invitees": this.inviteeIds,
       }
      if(this.inviteeIds.length > 0){
        ChannelApi.inviteUser(data_invitees).then(res => {    
          this.noChoosenUser = false
          this.inviteSearch = ''      // make with id
          this.userSuggestion = []         
         if(res.data.result){
          this.activeChannelDoc.invitations = []
          if(res.data.invitations.length > 0){                     
            res.data.invitations.forEach(currInvite => {                                   
              let invitaion_pending = {}
              if(typeof currInvite.invitee_id != 'undefined'){
                 invitaion_pending = {
                  "invitation_id": currInvite.invitation_id,
                  "user_cp_id" : currInvite.invitee_id
                }
              }else if(typeof currInvite.invitee_email != 'undefined'){
                 invitaion_pending = {
                  "invitation_id": currInvite.invitation_id,
                  "invitee_email" : currInvite.invitee_email
                }
              }              
              this.activeChannelDoc.invitations.push(invitaion_pending)
              let user_ids =  this.activeChannelDoc.user_ids
              user_ids.push(currInvite.invitee_id)
              if(typeof currInvite.invitee_id != 'undefined'){
                  ChannelNotification.ChannelInviteUser(this.activeChannelDoc,
                                                    SessionManager.getLoggedInUserId(), 
                                                    currInvite.invitation_id,
                                                    currInvite.invitee_id)   
              }
              ChannelApi.channelDetails(SessionManager.getActiveChannelId()).then(res=>{
                if(res.data.result){
                  SessionManager.setActiveChannelById(res.data.channel.channel_id)
                }
              })
              // else if(typeof currInvite.invitee_email != 'undefined'){
              //     ChannelNotification.ChannelInviteUser(this.activeChannelDoc,
              //                                       currInvite.invitee_email,
              //                                       currInvite.invitation_id)
              // }      
            })         
           }  
         }else {
           if(res.data.reason == "channel_already_exists"){
             SessionManager.setActiveChannelById(res.data.channel_id)
           }
         }
        }).then(res => {        
             this.inviteeIds = []
             this.response = "Users has been invited"         
             Global.globalValue(VueSignals.SHOW_MODAL, false)
        })
      }else {
        this.noChoosenUser = true
      }
     },  
     deleteInput(id){
      document.getElementById(id).outerHTML = ""
      this.invitationInputCounter--      
      this.inputFields.slice(this.inputFields.indexOf(this.invitationInputCounter),1)      
     },  
     highlightInput(id){
      document.getElementById(id).classList.add("hoverdanger");      
     },
     unHighlightInput(id){
      document.getElementById(id).classList.remove("hoverdanger");      
     }     
  }
}
